import { render } from "./satisfaction.vue?vue&type=template&id=b4c4e7ea&scoped=true"
import script from "./satisfaction.vue?vue&type=script&lang=js"
export * from "./satisfaction.vue?vue&type=script&lang=js"

import "./satisfaction.vue?vue&type=style&index=0&id=b4c4e7ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\prudentialBelife\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c4e7ea"]])

export default __exports__